import React, { FC } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import routes from './router';
import Error404 from './pages/Error-404-Page/error-404';
import PrivateLayout from 'components/Layout/private.component';



const AppRouter: FC = () => {
    return (
        <>
            <Router>
                <PrivateLayout>
                    <Routes>
                        {routes}
                        <Route path='*' element={<Error404 />} />
                    </Routes>
                </PrivateLayout>
            </Router>
        </>
    )
}

export default AppRouter;